module.exports = __webpack_public_path__ + "img/img25.5ee40fcc.png";